export function prepareOrder(order) {
  if (order?.child_orders?.length) {
    let additionalSum = 0;

    const splits = order.child_orders.reduce((splitOrders, childOrder) => {
      if (!childOrder.sum) {
        splitOrders.push({
          ...childOrder,
          _splitTitle: order.product_title,
        });
      } else {
        additionalSum += childOrder.sum;
      }
      return splitOrders;
    }, []);

    order._splits = splits;
    order._additionalSum = additionalSum;
  }

  return order;
}

export function prepareOrders(orders) {
  orders.forEach((order) => prepareOrder(order));

  return orders;
}
